import {
  EStudentWorksActions,
  StudentWorksActions,
} from './student-works.actions';
import {
  initialStudentWorkState,
  IStudentWorkState,
} from './student-works.state';

export const studentWorksReducers = (
  state = initialStudentWorkState,
  action: StudentWorksActions
): IStudentWorkState => {
  switch (action.type) {
    case EStudentWorksActions.AddStudentWork:
    case EStudentWorksActions.UpdateStudentWork:
      return {
        ...state,
        loading: { ...state.loading, add: true },
        success: false,
      };
    case EStudentWorksActions.AddStudentWorkFailure:
      return {
        ...state,
        loading: { ...state.loading, add: false },
        errors: { add: action.errors },
      };
    case EStudentWorksActions.AddStudentWorkSuccess:
    case EStudentWorksActions.UpdateStudentWorkSuccess:
      return {
        ...state,
        loading: { ...state.loading, add: false },
        errors: { add: {} },
        success: true,
      };

    case EStudentWorksActions.ClearAddStudentWorkErrors:
      return { ...state, errors: {}, success: false };

    case EStudentWorksActions.GetStudentWorks:
      return { ...state, loading: { ...state.loading, getAll: true } };
    case EStudentWorksActions.GetStudentWorksFailure:
      return { ...state, loading: { ...state.loading, getAll: false } };
    case EStudentWorksActions.GetStudentWorksSuccess:
      return {
        ...state,
        studentWorks: action.payload.results,
        count: action.payload.count,
        urgentHomeworksCount: action.payload.urgent_homeworks_count,
        challenge_count: action.payload.challenge_count,
        loading: { ...state.loading, getAll: false },
      };
    case EStudentWorksActions.ClearStudentWorks:
      return {
        ...state,
        studentWorks: [],
      };
    case EStudentWorksActions.GetStudentWorksStats:
      return { ...state, loading: { ...state.loading, stats: true } };
    case EStudentWorksActions.GetStudentWorksStatsFailure:
      return { ...state, loading: { ...state.loading, stats: false } };
    case EStudentWorksActions.GetStudentWorksStatsSuccess:
      return {
        ...state,
        newWorksStats: action.stats,
        loading: { ...state.loading, stats: false },
      };
    case EStudentWorksActions.GetStudentAllWorksStatsSuccess:
      return {
        ...state,
        allWorksStats: action.stats,
        newWorksStats: action.stats,
      };
    case EStudentWorksActions.ClearStudentAllWorksStats:
      return { ...state, allWorksStats: null };

    case EStudentWorksActions.GetWorkReview:
      return { ...state, loading: { ...state.loading, getReview: true } };
    case EStudentWorksActions.GetWorkReviewSuccess:
      return {
        ...state,
        loading: { ...state.loading, getReview: false },
        selectWorkReview: action.review,
      };
    case EStudentWorksActions.GetWorkReviewFailure:
      return { ...state, loading: { ...state.loading, getReview: false } };

    case EStudentWorksActions.EditWorkReview:
      return { ...state, loading: { ...state.loading, editReview: true } };
    case EStudentWorksActions.EditWorkReviewSuccess:
      if (action.review) {
        return {
          ...state,
          selectWorkReview: { ...state.selectWorkReview, ...action.review },
          loading: { ...state.loading, editReview: false },
        };
      }
      return { ...state, loading: { ...state.loading, editReview: false } };
    case EStudentWorksActions.EditWorkReviewFailure:
      return {
        ...state,
        loading: { ...state.loading, editReview: false },
      };

    case EStudentWorksActions.PublishReviews:
      return { ...state, publishLoading: true };
    case EStudentWorksActions.PublishReviewsSuccess: {
      const copyWorks = [...state.studentWorks];
      const works = copyWorks.filter(w => {
        const index = action.reviews.findIndex(
          review => w.review?.id === review?.id || false
        );
        return !(action.reviews[index]?.is_published || false);
      });
      return { ...state, studentWorks: works, publishLoading: false };
    }
    case EStudentWorksActions.PublishReviewsFailure:
      return { ...state, publishLoading: false };

    case EStudentWorksActions.TakeInCheckStudentWorksRequest:
      return { ...state, takeInCheckLoading: true };
    case EStudentWorksActions.TakeInCheckStudentWorksSuccess:
      return { ...state, takeInCheckLoading: false };
    case EStudentWorksActions.TakeInCheckStudentWorksFailure:
      return { ...state, takeInCheckLoading: false };

    case EStudentWorksActions.AutoAssignRequest:
      return { ...state, autoAssignLoading: true, autoAssignSuccess: false };
    case EStudentWorksActions.AutoAssignSuccess:
      return { ...state, autoAssignLoading: false, autoAssignSuccess: true };
    case EStudentWorksActions.AutoAssignFailure:
      return {
        ...state,
        autoAssignLoading: false,
        autoAssignSuccess: false,
        autoAssignErrors: action.errors,
      };
    case EStudentWorksActions.ClearAutoAssignErrors:
      return {
        ...state,
        autoAssignLoading: false,
        autoAssignSuccess: false,
        autoAssignErrors: null,
      };
    case EStudentWorksActions.GetReviewTemplatesRequest:
      return {
        ...state,
        reviewTemplatesLoading: true,
      };
    case EStudentWorksActions.GetReviewTemplatesSuccess:
      return {
        ...state,
        reviewTemplatesLoading: false,
        reviewTemplates: action.templates,
      };
    case EStudentWorksActions.GetReviewTemplatesFailure:
      return {
        ...state,
        reviewTemplatesLoading: false,
        errors: { add: action.errors },
      };
    default:
      return { ...state };
  }
};
